import { gql } from '@apollo/client'

export const CREATE_COUNTRY_VERSION = gql`
  mutation createCountryVersion($input: CreateCountryVersionInput!) {
    data: createCountryVersion(input: $input) {
      id
    }
  }
`
